webpackJsonp([17773661733558],{

/***/ 484:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Starter Blog","author":"Kyle Mathews"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/2017-11-15-wod/index.md absPath of file >>> MarkdownRemark","html":"<h2>Wednesday 11/15</h2>\n<p>For time:</p>\n<p>Run 1.5 miles\nBike 8 miles\n100 sit-ups</p>\n<p>Nutrition tune-up: check in on WAG!</p>\n<p></p>","frontmatter":{"title":"WOD 11.15.2017","date":"November 15, 2017"}}},"pathContext":{"path":"/wod-2017-11-15/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---wod-2017-11-15-d498c931d186849d8a25.js